<template>
  <div class="md-layout" style="background-color: #ffffff">
      <div class="md-layout-item md-small-size-100 mt-4">
          <h2 class="gestion-huella">GESTIÓN DE HUELLA</h2>
          <h2 class="gestion-huella" style="color: #707070">DE CARBONO CORPORATIVA </h2>
          <div class="left-side-img">
              <img alt="Alcances" src="@/assets/alcances.png"  />
          </div>
         
      </div>
      <div class="md-layout-item md-small-size-100 right-side-gestion mt-4">
          <h2 class="gestion-huella">GESTIÓN DE HUELLA</h2>
          <h2 class="gestion-huella" style="color: #707070">DE CARBONO DE PRODUCTO</h2>
          <img alt="Aguas arriba" src="@/assets/aguas-arriba.png" />
      </div>
       <div class="bg-color-green">
            <p>El cambio climático es la preocupación ambiental más grande con la que se ha visto enfrentada la humanidad. La solución está en nuestras manos, mide, reduce y neutraliza tu huella de carbono.</p>
        </div>
  </div>
</template>

<script>
export default {
    name: 'gestion'
}
</script>

<style>
.gestion-huella {
    font-size:2.5vw;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.18;
    letter-spacing: normal;
    text-align: center;
    color: #309645;
}

.left-side-img {
    border-right: solid 1px #adaaaa;
    width: 100%;
}
.left-side-img img {
    height: fit-content;
}
.bg-color-green {
    background-color: #309645;
    color: #ffffff;
    padding: 2vw 10vw 2vw 10vw;
}
.bg-color-green p {
    font-size: 1.8vw;
    line-height: 1.7;
}
</style>